/**
 * 환경별 개수
 * @see {@link https://wiki.daumkakao.com/pages/viewpage.action?pageId=702866260}
 * @type {{MAX_BIZ_CHANNELS: number, AD_GROUP_MAX_KEYWORDS: number, MAX_RESTRICTION_IPS: number, AD_GROUP_MAX_CREATIVES: number, BIZ_CHANNEL_MAX_CREATIVES: number, MAX_CAMPAIGNS: number, CAMPAIGN_MAX_AD_GROUPS: number}}
 */
import { isProduction } from 'utils'

const Limitations = {
  MAX_BIZ_CHANNELS: isProduction ? 1000 : 100,
  CAMPAIGN_MAX_AD_GROUPS: isProduction ? 1000 : 20,
  AD_GROUP_MAX_KEYWORDS: isProduction ? 1000 : 100,
  AD_GROUP_MAX_CREATIVES: isProduction ? 20 : 10,
  BIZ_CHANNEL_MAX_CREATIVES: isProduction ? 10000 : 10,
  MAX_RESTRICTION_IPS: isProduction ? 500 : 10,
  MAX_CAMPAIGNS: isProduction ? 1000 : 30,
  MAX_IMAGE_LIBRARIES: isProduction ? 10000 : 200,
}

export default Limitations
